import script from "./data-prereceiving-item.vue?vue&type=script&setup=true&lang=js"
export * from "./data-prereceiving-item.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__